import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import chevronForward from 'assets/icons/chevron-forward.svg';

const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom:  0 ,
  top: 'auto',
  width: '100%',
  transform: 'none',
  zIndex: 1000,
  background: '#F5F5F5',
  borderRadius:  '24px 24px 0px 0px' ,
  padding:  '16px 24px' ,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  cursor: 'pointer',
  boxShadow: '0px 0px 40px 0px rgba(0, 44, 87, 0.16)',

  transition: 'transform 0.3s ease',
  '&:hover': {
    transform:  'none',
  },
  '&.left': {
    right: 'auto',
    flexDirection: 'row-reverse',
  },
  '&.right': {
    left: 'auto',
    flexDirection: 'row',
  },
  [theme.breakpoints.up('sm')]: {
    padding: '10px',
    boxShadow:  '0px 4px 44px rgba(48, 94, 138, 0.2)',
    transform:  'translateY(calc(50% + 15px))',
    bottom:  'auto',
    display: 'flex',
    width: '150px',
    height: '70px',
    gap: '4px',
    '&.right:hover': {
      transform: `translateY(calc(50% + 15px)) translateX(5px)`,
    },
    '&.left:hover': {
      transform: `translateY(calc(50% + 15px)) translateX(-5px)`,
    },
    '&.left': {
      right: 0,
      borderRadius: '24px 0px 0px 24px',
      flexDirection: 'row-reverse',
    },
    '&.right': {
      left: 0,
      borderRadius: '0px 24px 24px 0px',
      flexDirection: 'row', 
    },
    background: 'linear-gradient(to left, #7A40E2 , #3866E5)',

  },
  [theme.breakpoints.up('lg')]: {
    width: '210px',
    padding: '20px 40px',
    height: '80px',
  },
}));

const ButtonContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  background: 'linear-gradient(to left, #7A40E2 , #3866E5)',
  width: '80%',
  padding:  '12px 16px 12px 12px' ,
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '12px',
  flexDirection: 'row-reverse',
  [theme.breakpoints.up('sm')]: {
    background: 'transparent',
    gap: '10px',
  },
  [theme.breakpoints.up('md')]: {
    background: 'none',
    gap: '8px',
    padding: '4px',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '8px',
  },
  [theme.breakpoints.up('xl')]: {
    gap: '10px',
  },
}));

const TextContainer = styled(Box)(({ }) => ({
  display: 'flex',
  flexDirection: 'column',
  '&.left': {
    alignItems: 'flex-start',
  },
  '&.right': {
    alignItems: 'flex-end',
  },
  gap: '4px',
}));

const ButtonText = styled('span')(({ theme }) => ({
  color: '#FFFFFF',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '100%',
  textAlign: 'center',
  '&.hide-for-mobile': {
    display: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    '&.hide-for-mobile': {
      display: 'unset',
    },
    textWrap: 'nowrap', 
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('lg')]: { 
    fontSize: '20px',
  },
}));

const ChevronIcon = styled('img')(({theme}) => ({
  width: '10px',
  height: '10px',
  transform: 'rotate(0deg)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '12px',
    height: '12px',
  },
  [theme.breakpoints.up('md')]: {
    width: '8px',
    height: '8px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '10px',
    height: '10px',
  },
  [theme.breakpoints.up('xl')]: {
    width: '14px',
    height: '14px',
  },
}));

const FixedButton = ({ 
  onClick, 
  position = 'left', // 'left' or 'right'
  top = 'calc(50% + 15px)' , // can be any valid CSS value like '50%', '100px', etc.
}) => {
  
  return (
    <ButtonWrapper
     onClick={onClick} 
     position={position} 
     className={position}
     sx={{
      top:{md: '40%', xl: '45%'}
     }}
      testid="fixed-button-fixed-button-customer-join">
      <ButtonContent >
        <ChevronIcon src={chevronForward} alt="Forward" testid="chevron-icon-fixed-button-customer-join" />
        <TextContainer className={position} testid="text-container-fixed-button-customer-join">
          <ButtonText className={'hide-for-mobile'} testid="button-text-1-fixed-button-customer-join">נשמע מעניין,</ButtonText>
          <ButtonText  testid="button-text-2-fixed-button-customer-join">אני רוצה להצטרף</ButtonText>
        </TextContainer>
      </ButtonContent>
    </ButtonWrapper>
  );
};

export default FixedButton; 